
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Weight, UserSquare2, Heart, PencilRuler, Syringe, Pill } from 'lucide-react';

interface CategoryTabsProps {
  scrollToCategory: (categoryId: string) => void;
  categoryCounts: Record<string, number>;
  searchTerm: string;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({ 
  scrollToCategory, 
  categoryCounts, 
  searchTerm 
}) => {
  return (
    <Tabs defaultValue="weight-loss" className="w-full">
      <TabsList className="justify-start overflow-x-auto no-scrollbar px-1 py-0.5 flex-nowrap gap-1 md:gap-0">
        <TabsTrigger 
          value="weight-loss" 
          onClick={() => scrollToCategory('weight-loss')} 
          className="whitespace-nowrap min-w-fit flex-shrink-0"
          disabled={categoryCounts['weight-loss'] === 0}
        >
          <Weight className="mr-1 md:mr-2 h-4 w-4" />
          <span className="md:inline text-xs md:text-sm">Weight Loss</span>
          {searchTerm && <span className="ml-1 text-xs">({categoryCounts['weight-loss']})</span>}
        </TabsTrigger>
        <TabsTrigger 
          value="mens-health" 
          onClick={() => scrollToCategory('mens-health')} 
          className="whitespace-nowrap min-w-fit flex-shrink-0"
          disabled={categoryCounts['mens-health'] === 0}
        >
          <UserSquare2 className="mr-1 md:mr-2 h-4 w-4" />
          <span className="md:inline text-xs md:text-sm">Men's Health</span>
          {searchTerm && <span className="ml-1 text-xs">({categoryCounts['mens-health']})</span>}
        </TabsTrigger>
        <TabsTrigger 
          value="womens-health" 
          onClick={() => scrollToCategory('womens-health')} 
          className="whitespace-nowrap min-w-fit flex-shrink-0"
          disabled={categoryCounts['womens-health'] === 0}
        >
          <Heart className="mr-1 md:mr-2 h-4 w-4" />
          <span className="md:inline text-xs md:text-sm">Women's Health</span>
          {searchTerm && <span className="ml-1 text-xs">({categoryCounts['womens-health']})</span>}
        </TabsTrigger>
        <TabsTrigger 
          value="peptides" 
          onClick={() => scrollToCategory('peptides')} 
          className="whitespace-nowrap min-w-fit flex-shrink-0"
          disabled={categoryCounts['peptides'] === 0}
        >
          <PencilRuler className="mr-1 md:mr-2 h-4 w-4" />
          <span className="md:inline text-xs md:text-sm">Peptides</span>
          {searchTerm && <span className="ml-1 text-xs">({categoryCounts['peptides']})</span>}
        </TabsTrigger>
        <TabsTrigger 
          value="injectables" 
          onClick={() => scrollToCategory('injectables')} 
          className="whitespace-nowrap min-w-fit flex-shrink-0"
          disabled={categoryCounts['injectables'] === 0}
        >
          <Syringe className="mr-1 md:mr-2 h-4 w-4" />
          <span className="md:inline text-xs md:text-sm">Injectables</span>
          {searchTerm && <span className="ml-1 text-xs">({categoryCounts['injectables']})</span>}
        </TabsTrigger>
        <TabsTrigger 
          value="additional" 
          onClick={() => scrollToCategory('additional')} 
          className="whitespace-nowrap min-w-fit flex-shrink-0"
          disabled={categoryCounts['additional'] === 0}
        >
          <Pill className="mr-1 md:mr-2 h-4 w-4" />
          <span className="md:inline text-xs md:text-sm">Additional</span>
          {searchTerm && <span className="ml-1 text-xs">({categoryCounts['additional']})</span>}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default CategoryTabs;
